import * as Sentry from "@sentry/react";

function traceSampleRate() {
  const configured = Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0.05);
  if (!Number.isFinite(configured)) return 0.05;
  return Math.min(1, Math.max(0, configured));
}

export function initErrorMonitoring() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return false;

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",
    release: process.env.REACT_APP_SENTRY_RELEASE,
    sendDefaultPii: false,
    tracesSampleRate: traceSampleRate(),
  });
  return true;
}
